/** @jsx jsx */
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import {jsx, css} from '@emotion/react'
import {useStaticQuery, graphql} from 'gatsby'

const Hero = ({title, image}) => {
    const heroImage = useStaticQuery(graphql`
        query AdvertorialHeroImage {
            heroImage: file(relativePath: {eq: "advertorial/shopping/shopping-hero.png"}) {
                childImageSharp {
                    fluid(maxWidth: 1000) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)
    return (
        <section>
            <h1
                css={css`
                    margin: 2.5rem 0 1.25rem;
                    font-family: 'Proxima Nova Bold', sans-serif;
                    font-size: 2.5rem;
                    font-size: min(max(1.6rem, 4vw), 3rem);
                `}
            >
                {title}
            </h1>
            <Img fluid={image || heroImage.heroImage.childImageSharp.fluid} />
        </section>
    )
}

Hero.propTypes = {
    title: PropTypes.string,
    image: PropTypes.object,
}

Hero.defaultProps = {
    title: ``,
    image: {},
}

export default Hero
